/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FreshserviceMappingBase {
    getFixupPrototypeFunction() { return FreshserviceMappingBase.fixupPrototype; }

    static newInstance(model: Partial<FreshserviceMappingBase>): FreshserviceMappingBase {
        let obj = Object.assign(new FreshserviceMappingBase(), model);
        FreshserviceMappingBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FreshserviceMappingBase>): FreshserviceMappingBase {
        if (!model) return null;
        return FreshserviceMappingBase.newInstance(<FreshserviceMappingBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FreshserviceMappingBase) {
        if (!obj) return;

        models.FreshserviceMappingBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FreshserviceMappingBase): boolean {
        Object.setPrototypeOf(obj, FreshserviceMappingBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Sample Format text of incident description by selected description attributes.
     */
    description_text: string;

}
